import React from 'react';
import './PolicyPage.css';

const FAQs: React.FC = () => (
  <main className="policy-page">
    <h1>Frequently Asked Questions</h1>
    <section className="faq-list">
      <details><summary>Where is Gimbiya Value Store located?</summary><p>Our business is based in Zango, Zaria, Kaduna State, Nigeria.</p></details>
      <details><summary>How long does delivery take?</summary><p>Delivery is estimated within 24 hours in Zaria and Kaduna, and 1–3 days outside Zaria and Kaduna.</p></details>
      <details><summary>Do you charge shipping fees?</summary><p>Shipping is free. A minimum order value of ₦15,000 is required to place an order.</p></details>
      <details><summary>How do I pay?</summary><p>Checkout uses Paystack. Available payment channels depend on what Paystack displays for your transaction.</p></details>
      <details><summary>How do I track my order?</summary><p>Sign in and open My Orders to view available order and tracking information.</p></details>
      <details><summary>How do I request a return?</summary><p>Open My Orders and use the available return option, or contact support before sending an item back.</p></details>
      <details><summary>Who pays return shipping?</summary><p>The buyer generally pays return shipping according to prevailing market rates, unless we confirm otherwise in writing.</p></details>
      <details><summary>Do all products have a warranty?</summary><p>No universal warranty is promised. Warranty coverage applies only where provided by the manufacturer and is subject to its terms.</p></details>
      <details><summary>How can I contact support?</summary><p>Send an email to hello@gimbiyastore.com.</p></details>
    </section>
  </main>
);
export default FAQs;
